import { useNavigate } from 'react-router-dom';
import { askBeforeLeaving } from './useLeaveGuard';

/**
 * Hook that returns a navigation handler supporting Cmd+Click (Mac) / Ctrl+Click (Windows/Linux)
 * to open links in a new tab.
 *
 * Usage:
 * ```tsx
 * const navigateTo = useNavigateWithNewTab();
 * <button onClick={navigateTo('/coding')}>Medical Coding</button>
 * ```
 */
export function useNavigateWithNewTab() {
  const navigate = useNavigate();

  return (path: string) => (e: React.MouseEvent) => {
    if (e.metaKey || e.ctrlKey) {
      window.open(path, '_blank');
    } else if (!askBeforeLeaving(() => navigate(path))) {
      navigate(path);
    }
  };
}
